import HomepageOverlay from "./HomepageOverlay";
import PropTypes from 'prop-types'
import find from "lodash/find";
import { quickLinksHome, quickLinksServices } from '../config'
import { useEffect, useState } from "react";
import AdventStore from "../store/Advent.store";
import LoadingPageOverlay from "./LoadingPageOverlay";
import t from '../service/translate.service'
import { Link } from "react-router-dom";
import { appFeatureEnabled } from "../service/appFeatures.service";

const TenantServicesList = ({onClick, User}) => {
  const [quickLinks, setQuickLinks] = useState([])
  const [loading, setLoading] = useState([])
  const hasActiveContracts = Boolean(find(User.contracts, (c) => c.valid && c.active));

  useEffect(() => { 
    (async () => {
      setLoading(true)
      const quickLinks = window.location.pathname === '/' ? quickLinksHome : quickLinksServices
      try {
        const extraContent = []
        if(appFeatureEnabled('eventsEnabledWeb')) {
          const res = await AdventStore.getAll()
          for (let i = 0; i < res?.rows?.length; i++) {
            const item = res?.rows[i]
            if (item.active) {
              extraContent.push({
                image: <img src={`${item.icon}`} alt={`${item.name}`} />,
                name: localStorage?.getItem('locale') === 'en' ? item.name : item.nameDe,
                link: item.url,
                showNewBanner: item.showNewBanner,
                external: true
              })
            }
          } 
        }
        const insert = (arr, index, ...newItems) => [
          ...arr.slice(0, index),
          ...newItems,
          ...arr.slice(index)
        ]
        const result = appFeatureEnabled('eventsEnabledWeb') ?  insert(quickLinks, 1, ...extraContent) : quickLinks
        setQuickLinks(result)
      } catch (err) {
        console.log(err)
        setQuickLinks(quickLinks)
      }
      setLoading(false)
    })()
  }, [])

  return (
    <div className="tenant-services-list welcome">
      {loading && <LoadingPageOverlay />}
      {hasActiveContracts ? <span aria-hidden="true" /> : <HomepageOverlay />}
      {quickLinks.map((item, index) => {
        if (item.link === '/letters' && !(appFeatureEnabled('lettersEnabled', User.contracts) || appFeatureEnabled('lettersEnabledForCondo', User.contracts))) return null
        if (item.feature && !appFeatureEnabled(item.feature, User.contracts)) return null
        var iconClass = item.showNewBanner ? "newBadge" : "";
        if (localStorage.getItem("locale") === "de") iconClass += " de";
        
  
        return (
          <div key={item.link} className={`item`}>
            <div className={`container ${iconClass}`}>
              {item.external ? (
                <a 
                  href={item.link} 
                  rel="nofollow noreferrer noopener" 
                  target="_blank" 
                  className="service-link" 
                  aria-label={[t.OPEN_TAB_1, item.name, t.OPEN_TAB_2].join(' ')}
                >
                  <div className="image">{item.image}</div>
                  <div className="name">{item.name}</div>
                </a>
              ) : (
                <Link
                  onClick={() => onClick(item.link)}
                  to={item.link}
                  aria-label={`${t.GOTO} ${item.name}`}
                >
                  <div className="image">{item.image}</div>
                  <div className="name">{item.name}</div>
                </Link>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

TenantServicesList.propTypes = {
  onClick: PropTypes.func.isRequired,
  User: PropTypes.object.isRequired
}

export default TenantServicesList;